import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
import { SignupData } from '../../pages/SignupPage';
interface SignupSuccessProps {
  data: SignupData;
}
const SignupSuccess: React.FC<SignupSuccessProps> = ({
  data
}) => {
  const getProfileTypeLabel = (type: string) => {
    const types: Record<string, string> = {
      player: 'Player',
      coach: 'Coach',
      manager: 'Manager',
      agent: 'Agent',
      scout: 'Scout',
      referee: 'Referee',
      journalist: 'Journalist',
      fan: 'Fan'
    };
    return types[type] || type;
  };
  const getSportLabel = (sport: string) => {
    const sports: Record<string, string> = {
      football: 'Football',
      basketball: 'Basketball',
      baseball: 'Baseball',
      tennis: 'Tennis',
      golf: 'Golf',
      volleyball: 'Volleyball',
      rugby: 'Rugby',
      hockey: 'Hockey',
      cricket: 'Cricket',
      swimming: 'Swimming',
      athletics: 'Athletics',
      cycling: 'Cycling'
    };
    return sports[sport] || sport;
  };
  // Function to render profile-specific details
  const renderProfileDetails = () => {
    const details = data.profileDetails || {};
    switch (data.profileType) {
      case 'player':
        return <>
            {details.position && <div className="flex justify-between" data-id="element-244">
                <span className="text-gray-500" data-id="element-245">Position:</span>
                <span className="font-medium" data-id="element-246">{details.position}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-247">
                <span className="text-gray-500" data-id="element-248">Experience:</span>
                <span className="font-medium" data-id="element-249">{details.experience} years</span>
              </div>}
            {details.currentTeam && <div className="flex justify-between" data-id="element-250">
                <span className="text-gray-500" data-id="element-251">Current Team:</span>
                <span className="font-medium" data-id="element-252">{details.currentTeam}</span>
              </div>}
          </>;
      case 'coach':
        return <>
            {details.coachingSpecialty && <div className="flex justify-between" data-id="element-253">
                <span className="text-gray-500" data-id="element-254">Specialty:</span>
                <span className="font-medium" data-id="element-255">{details.coachingSpecialty}</span>
              </div>}
            {details.coachingLevel && <div className="flex justify-between" data-id="element-256">
                <span className="text-gray-500" data-id="element-257">Level:</span>
                <span className="font-medium" data-id="element-258">{details.coachingLevel}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-259">
                <span className="text-gray-500" data-id="element-260">Experience:</span>
                <span className="font-medium" data-id="element-261">{details.experience} years</span>
              </div>}
          </>;
      case 'manager':
        return <>
            {details.managementSpecialty && <div className="flex justify-between" data-id="element-262">
                <span className="text-gray-500" data-id="element-263">Specialty:</span>
                <span className="font-medium" data-id="element-264">
                  {details.managementSpecialty}
                </span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-265">
                <span className="text-gray-500" data-id="element-266">Experience:</span>
                <span className="font-medium" data-id="element-267">{details.experience} years</span>
              </div>}
          </>;
      case 'agent':
        return <>
            {details.agencyName && <div className="flex justify-between" data-id="element-268">
                <span className="text-gray-500" data-id="element-269">Agency:</span>
                <span className="font-medium" data-id="element-270">{details.agencyName}</span>
              </div>}
            {details.clientCount && <div className="flex justify-between" data-id="element-271">
                <span className="text-gray-500" data-id="element-272">Clients:</span>
                <span className="font-medium" data-id="element-273">{details.clientCount}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-274">
                <span className="text-gray-500" data-id="element-275">Experience:</span>
                <span className="font-medium" data-id="element-276">{details.experience} years</span>
              </div>}
          </>;
      case 'scout':
        return <>
            {details.scoutingSpecialty && <div className="flex justify-between" data-id="element-277">
                <span className="text-gray-500" data-id="element-278">Specialty:</span>
                <span className="font-medium" data-id="element-279">{details.scoutingSpecialty}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-280">
                <span className="text-gray-500" data-id="element-281">Experience:</span>
                <span className="font-medium" data-id="element-282">{details.experience} years</span>
              </div>}
          </>;
      case 'referee':
        return <>
            {details.refereeLevel && <div className="flex justify-between" data-id="element-283">
                <span className="text-gray-500" data-id="element-284">Level:</span>
                <span className="font-medium" data-id="element-285">{details.refereeLevel}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-286">
                <span className="text-gray-500" data-id="element-287">Experience:</span>
                <span className="font-medium" data-id="element-288">{details.experience} years</span>
              </div>}
          </>;
      case 'journalist':
        return <>
            {details.publication && <div className="flex justify-between" data-id="element-289">
                <span className="text-gray-500" data-id="element-290">Publication:</span>
                <span className="font-medium" data-id="element-291">{details.publication}</span>
              </div>}
            {details.experience && <div className="flex justify-between" data-id="element-292">
                <span className="text-gray-500" data-id="element-293">Experience:</span>
                <span className="font-medium" data-id="element-294">{details.experience} years</span>
              </div>}
          </>;
      case 'fan':
        return <>
            {details.experience && <div className="flex justify-between" data-id="element-295">
                <span className="text-gray-500" data-id="element-296">Following Sport:</span>
                <span className="font-medium" data-id="element-297">{details.experience} years</span>
              </div>}
            {details.favoriteTeams && details.favoriteTeams.length > 0 && <div className="flex justify-between" data-id="element-298">
                <span className="text-gray-500" data-id="element-299">Favorite Team:</span>
                <span className="font-medium" data-id="element-300">{details.favoriteTeams[0]}</span>
              </div>}
          </>;
      default:
        return null;
    }
  };
  return <div className="flex flex-col items-center justify-center p-6 h-full" data-id="element-301">
      <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6" data-id="element-302">
        <CheckCircleIcon size={40} className="text-green-600" data-id="element-303" />
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-304">Account Created!</h1>
      <p className="text-gray-600 text-center mb-6" data-id="element-305">
        Welcome to SportProz, {data.fullName}!
      </p>
      <div className="w-full bg-gray-50 rounded-lg p-4 mb-6" data-id="element-306">
        <h3 className="font-medium mb-2" data-id="element-307">Your Profile Summary</h3>
        <div className="space-y-2 text-sm" data-id="element-308">
          <div className="flex justify-between" data-id="element-309">
            <span className="text-gray-500" data-id="element-310">Name:</span>
            <span className="font-medium" data-id="element-311">{data.fullName}</span>
          </div>
          <div className="flex justify-between" data-id="element-312">
            <span className="text-gray-500" data-id="element-313">Username:</span>
            <span className="font-medium" data-id="element-314">@{data.username}</span>
          </div>
          <div className="flex justify-between" data-id="element-315">
            <span className="text-gray-500" data-id="element-316">Sport:</span>
            <span className="font-medium" data-id="element-317">{getSportLabel(data.sport)}</span>
          </div>
          <div className="flex justify-between" data-id="element-318">
            <span className="text-gray-500" data-id="element-319">Profile Type:</span>
            <span className="font-medium" data-id="element-320">
              {getProfileTypeLabel(data.profileType)}
            </span>
          </div>
          {/* Profile-specific details */}
          {renderProfileDetails()}
        </div>
      </div>
      <div className="space-y-3 w-full" data-id="element-321">
        <Link to="/" className="block w-full bg-blue-600 text-white text-center py-3 rounded-lg font-medium" data-id="element-322">
          Go to Home
        </Link>
        <Link to="/profile" className="block w-full bg-gray-100 text-gray-800 text-center py-3 rounded-lg font-medium" data-id="element-323">
          Complete Your Profile
        </Link>
      </div>
    </div>;
};
export default SignupSuccess;